module.exports = __webpack_public_path__ + "img/news4.d3ac8bcc.jpg";